import { render } from "./Card.vue?vue&type=template&id=aeec6b50&scoped=true&bindings={\"width\":\"props\",\"height\":\"props\",\"background\":\"props\",\"mt\":\"props\",\"mb\":\"props\",\"ml\":\"props\",\"mr\":\"props\",\"padding\":\"props\",\"borderRadius\":\"props\"}"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=aeec6b50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aeec6b50"

export default script